module.exports = __webpack_public_path__ + "static/media/4.28376719.svg";